import {Project} from "../types";

export class MopsTOMLGenerator {
    constructor(private project: Project) {}

    generateMopsToml(): string {
        // Get Motoko packages from the project
        const motokoPackages = this.project.motokoPackages?.[0] || [];

        // Format as TOML
        let toml = `[dependencies]\n`;

        motokoPackages.forEach(pkg => {
            // Format version appropriately - MOPS uses "=" for exact versions
            toml += `${pkg.name} = "${pkg.version}"\n`;
        });

        // Add standard mops.toml configuration
        toml += `\n[package]\n`;
        toml += `name = "${this.project.name}"\n`;
        toml += `version = "0.1.0"\n`;
        toml += `description = "${this.project.description?.[0] || ""}"\n`;

        return toml;
    }
}